import React, { Fragment } from 'react'
import HeaderBotton from '../../../components/HeaderBottom'
import HeaderTop from '../../../components/HeaderTop'
import Breadcumb from '../../../components/Breadcumb'
import TeamMember from '../../../components/TeamMember'
import NewsLetter from '../../../components/Newsletter'
import FooterArea from '../../../components/FooterArea'
// images
import breadcumb from '../../../images/breadcumb/1.jpg'

import './style.scss'
import ContactArea from '../../../components/ContactArea'

const breadcumbMenu = [
    { name: 'Home', route: '/' },
    { name: 'Our Team' }
]

const TeamPage = () => {
    return (
        <Fragment>
            <header className="headerArea">
            <HeaderBotton className="headerBottomArea " />
                <HeaderTop className="headerTop" />
                {/* <HeaderBotton className="headerBottomArea headerBottomAreaStyelTwo" /> */}
            </header>
            <Breadcumb
                className="breadcumbArea"
                title="Anmoldeep Kaur"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />
            <TeamMember
                teamId={7}
                title="Qualified Attorneys "
                subTitle="Meet Our Experts"
                className="teamArea teamAreaStyleTwo"
                noGutters={true}
            />
           <ContactArea
                className="contactArea"
            />
            <FooterArea />
        </Fragment>
    )
}
export default TeamPage